<script>
    import _                from 'lodash'
    import { onMount }      from 'svelte'
    import * as api         from '../../shared/api.js'
    import { processors }   from '../../shared/stores.js'
    import AppLoader        from '../../shared/Loader.svelte'
    import Item             from '../../shared/Item.svelte'
    import SectionTitle     from '../../shared/SectionTitle.svelte'
    import ProcessorItem    from './ProcessorItem.svelte'

    let active    = -1
    let buffer    = []
    let domain    = null
    let loading   = true
    let error     = false
    let archetype = empty()

    function empty() {
        return { id: 0, name: '', contact: '', international: false}
    }

    function sort(it) {
        return it.name
    }

    function onUpdate(it) {
        const method = it.id === 0 ? 'POST' : 'PUT'
        return api
            .exec('/processor', method, it)
            .then(api.toJsonIf200)
            .then(json => {
                archetype = empty()
                let array = buffer
                let toAdd = json
                if(it.id > 0) {
                    array = buffer.filter(i => i.id !== it.id)
                    toAdd = it
                }
                buffer = _.sortBy([...array, toAdd], sort)
                processors.set(buffer) 

                return true
            }).catch(err => {
                console.log(err)
                return err.text().then(text => { throw text })
            })
    }

    function onRemove(it) {
        return api
            .del(`/processor/${it.id}`)
            .then(res => {
                if(res.status === 200) {
                    buffer = buffer.filter(i => i.id !== it.id)
                    processors.set(buffer)
                    return true
                } else {
                    throw 'Error removing processor'
                }
            })
    }

    api
        .get('/processors')
        .then(api.toJsonIf200)
        .then(json => {
            loading = false
            buffer = json
        })
        .catch(err => {
            loading = false
            error = err
        })
</script>

<svelte:head>
	<title>Dogma / Operadores</title>
</svelte:head>

{#if loading || error}
    <AppLoader {error} what="Carregando"  inverted={true}/>
{:else}
    <SectionTitle>Operadores</SectionTitle>
    <div class="ui raised segments">
        <ProcessorItem 
            bind:active={active} 
            bind:item={archetype} 
            {onUpdate} 
            withHeader={false}
        />
        {#each buffer as item (item.id)}
            <ProcessorItem 
                bind:active={active} 
                bind:item={item} 
                {onUpdate} 
                {onRemove} 
            />
        {/each}
    </div>
{/if}